import * as pollers from '../../../api/pollers/pollers';
import getNewpayWallet from '../../../selectors/getNewpayWallet';
import Track from '../../../utils/tracking';
import startNewpayCheckout from './startNewpayCheckout';
import updateNewpayStatus from './updateNewpayStatus';

const checkoutWithNewpay = (checkoutCertificate, stopWithError) => (dispatch, getState) => {
  pollers.placeOrderViaApiPoller.stopPoller();
  const wallet = getNewpayWallet(getState());
  if (wallet) {
    wallet.checkout(() => startNewpayCheckout(checkoutCertificate, dispatch))
      .then(() => updateNewpayStatus('SUCCESS', dispatch, stopWithError))
      .catch((error) => {
        updateNewpayStatus('FAILURE', dispatch, stopWithError);
        Track.error(`Error processing newpay payment: ${error}`);
        return error;
      });
  } else {
    Track.error('Attempted to checkout with newpay but no init token was found');
    stopWithError();
  }
};

export default checkoutWithNewpay;
